import React, { useState } from 'react';
import { forgotPassword } from '../../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | done | error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    setMessage('');
    try {
      const res = await forgotPassword(email);
      setStatus('done');
      setMessage(res.message || 'If that email exists, a reset link has been sent.');
    } catch (err) {
      console.error(err);
      setStatus('error');
      setMessage(err.response?.data?.message || 'An error occurred. Please try again later.');
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="card shadow">
            <div className="card-header bg-conference-gradient text-white text-center">
              <h3 className="mb-0">Forgot Password</h3>
            </div>
            <div className="card-body p-4">
              {status === 'done' ? (
                <div className="text-center">
                  <i className="bi bi-envelope-check text-success" style={{ fontSize: '3.5rem' }}></i>
                  <h5 className="mt-3 text-success">Check Your Email</h5>
                  <p className="text-muted">{message}</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  {status === 'error' && (
                    <div className="alert alert-danger py-2">{message}</div>
                  )}
                  <button
                    type="submit"
                    className="btn btn-conference-primary w-100"
                    disabled={status === 'submitting'}
                  >
                    {status === 'submitting' ? 'Sending...' : 'Send Reset Link'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
